import CustomButton from '../../../components/Buttons/CustomButton';
import AddButton from '../../../components/Buttons/AddButton';
import { changeMultipleBidStatus } from '../../../api/Commerce';
import { useEffect, useState } from 'react';

function BiddingsButtonSection({
  competitionId,
  competitionStatus,
  vehicles,
  setShowNewBidModal,
  fetchData,
}) {
  const [disableCloseAllBtn, setDisableCloseAllBtn] = useState(false);
  const [disableOpenAllBtn, setDisableOpenAllBtn] = useState(false);

  useEffect(() => {
    const vehicleClosedForBids = (currentValue) =>
      currentValue.bidStatus === 'closedforbids';
    const vehicleOpenForBids = (currentValue) =>
      currentValue.bidStatus === 'openforbids';

    const allVehiclesClosedForBids = vehicles.every(vehicleClosedForBids);
    const allVehiclesOpenForBids = vehicles.every(vehicleOpenForBids);

    if (allVehiclesClosedForBids) {
      setDisableCloseAllBtn(true);
    } else {
      setDisableCloseAllBtn(false);
    }

    if (allVehiclesOpenForBids) {
      setDisableOpenAllBtn(true);
    } else {
      setDisableOpenAllBtn(false);
    }
  }, [vehicles]);

  const addBidBtn = (
    <>
      {competitionStatus === 'Pågående' && vehicles.length !== 0 ? (
        <AddButton
          text='Lägg till anbud'
          onClick={() => setShowNewBidModal(true)}
        />
      ) : (
        <AddButton
          text='Lägg till anbud'
          onClick={() => setShowNewBidModal(true)}
          disabled={true}
        />
      )}
    </>
  );

  const openAllForBids = async () => {
    const result = await changeMultipleBidStatus(competitionId, 'openforbids');

    if (result.statusCode === 200) {
      await fetchData();
    }
  };

  const closeAllForBids = async () => {
    const result = await changeMultipleBidStatus(
      competitionId,
      'closedforbids'
    );

    if (result.statusCode === 200) {
      await fetchData();
    }
  };

  return (
    <div className='d-flex flex-column flex-sm-row justify-content-between gap-2'>
      {addBidBtn}
      <div className='d-flex flex-column flex-sm-row gap-2'>
        <CustomButton
          title='Öppna alla för anbud'
          onClick={openAllForBids}
          icon='lock_open'
          disabled={competitionStatus !== 'Pågående' || disableOpenAllBtn}
        />
        <CustomButton
          title='Stäng alla för anbud'
          onClick={closeAllForBids}
          icon='lock'
          disabled={competitionStatus !== 'Pågående' || disableCloseAllBtn}
        />
      </div>
    </div>
  );
}

export default BiddingsButtonSection;
